import { ILoginPayload } from '../../types/api/request/authrequest';
import { ILoginResponse } from '../../types/api/response/authresponse';
import axiosClient from '../axiosClient';
import { AuthEndpoint } from '../endpoints/auth';

export const AuthService = {
  async login(data: ILoginPayload): Promise<ILoginResponse> {
    const res = await axiosClient.post<ILoginResponse>(AuthEndpoint.LOGIN, data);

    return res.data;
  },
};
